import React from 'react';
import {NavLink} from "react-router-dom";
import {MobileDropdownItem, DesktopDropdownItem} from './DropdownItems';

const LinkBlock = (props) => {
    const {itemKey, title, slug, sitePrefix, subtitle, type, external_url, background_image} = props;
    const link_class = 'menu-item-' + type.toLowerCase();
    if (type === 'externalLink') {
        return (
            <>
                <a href={external_url} key={itemKey} className={`menu-item d-block d-md-none ${link_class}`}>

                    {!!background_image && <img src={background_image} style={{width: '100%'}}/>}
                    {!background_image && title}

                    <span className="d-none d-md-block small">{subtitle}</span>
                </a>
                <a href={external_url} key={itemKey} className={`menu-item d-none d-md-block ${link_class}`} target="_blank">

                    {!!background_image && <img src={background_image} style={{width: '100%'}}/>}
                    {!background_image && title}

                    <span className="d-none d-md-block small">{subtitle}</span>
                </a>
            </>
        )
    }

    if (type === 'Dropdown' || type === 'documentatieLijst') {
        return (
            <div className={`dropdown ${link_class}`}>
                <MobileDropdownItem title={title} subtitle={subtitle}/>
                <div key={itemKey}
                     className={"dropdown-right dropdown dropdown-menu-sub"}>
                </div>
                <DesktopDropdownItem
                    active={true}
                    title={title}
                    subtitle={subtitle}/>
            </div>
        )
    }

    return (
        <NavLink key={itemKey} className={`menu-item ${link_class}`}
                 to={sitePrefix + slug}
                 activeClassName="active"
                 path={sitePrefix + slug}>
            {title}
            <span className="d-none d-md-block small">{subtitle}</span>
        </NavLink>
    )


}

export default LinkBlock;
